(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["buy-button"] && !Shopify.designMode) return;
  try {
    
/* Verschiebt den Kaufblock in einen Platzhalter, der im Produkttext steht.
   Nötig, weil der Produkttext eine einzige Section ist und der Theme-Editor
   dort nichts dazwischen setzen kann. */
(function () {
  function placeBlocks() {
    var blocks = document.querySelectorAll('.cnc-buy[data-slot]');
    Array.prototype.forEach.call(blocks, function (block) {
      var slot = block.getAttribute('data-slot');
      if (!slot || block.dataset.cncPlaced === 'true') return;
      var target =
        document.querySelector('[data-cnc-buy-slot="' + slot + '"]') ||
        document.getElementById('cnc-buy-slot-' + slot);
      if (!target || target.contains(block)) return;
      target.appendChild(block);
      block.dataset.cncPlaced = 'true';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', placeBlocks);
  } else {
    placeBlocks();
  }
  document.addEventListener('shopify:section:load', placeBlocks);
})();

document.addEventListener('click', function (event) {
  var trigger = event.target.closest('[data-cnc-buy-add]');
  if (!trigger) return;
  event.preventDefault();

  /* Den echten Kaufen-Button der Produktsection anklicken, damit Variante,
     Menge und der Warenkorb-Drawer genau wie gewohnt funktionieren. */
  var selectors = [
    '.product-section form[action*="/cart/add"] [name="add"]',
    '.product-section form[action*="/cart/add"] [type="submit"]',
    'form[action*="/cart/add"] [name="add"]',
    'form[action*="/cart/add"] [type="submit"]'
  ];

  for (var i = 0; i < selectors.length; i++) {
    var candidates = document.querySelectorAll(selectors[i]);
    for (var j = 0; j < candidates.length; j++) {
      var button = candidates[j];
      if (button.closest('.cnc-buy') || button.disabled) continue;
      button.click();
      trigger.classList.add('is-busy');
      window.setTimeout(function () {
        trigger.classList.remove('is-busy');
      }, 1200);
      return;
    }
  }

  /* Notfalls direkt in den Warenkorb legen */
  var id = trigger.getAttribute('data-variant-id');
  if (!id) return;
  trigger.classList.add('is-busy');
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
  })
    .then(function () {
      window.location.href = '/cart';
    })
    .catch(function () {
      trigger.classList.remove('is-busy');
    });
});

  } catch(e) { console.error(e); }
})();
})();
